import $ from 'jquery';

const header = () => {
  const body = $('body');
  const header = $('.header'); 
  const togglerMobileMenu = $('.navbar-toggler');
  const mobileMenu = $('.header__nav-mobile');
  const mobileMenuToggleSubmenu = $('.header__nav-mobile .menu-item-has-children > a')
  const toggleSubmenu = $('.header__nav-main ul .menu-item-has-children');
  const links = $('a[href^="#"]')

  let scrollPosition = 0;
  function lockScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
    const scrollbarComp = window.innerWidth - document.documentElement.clientWidth;
    body
      .addClass('disabled')
      .css({
        position: 'fixed',
        top: -scrollPosition + 'px',
        width: '100%',
        paddingRight: scrollbarComp > 0 ? scrollbarComp + 'px' : '',
      });
  }
  function unlockScroll() {
    body
      .removeClass('disabled')
      .css({ position: '', top: '', width: '', paddingRight: '' });
    window.scrollTo(0, scrollPosition || 0);
  }

  function toggleHeaderScrolled() {
    $(window).on('scroll', function () {
      if ($(window).scrollTop() > 40) {
        header.addClass('header-scrolled');
      } else {
        header.removeClass('header-scrolled');
      }
    });
  }

  links.on('click', function(e) {
    e.preventDefault()
  })

  function toggleMobileMenu() {
    togglerMobileMenu.on('click', function () {
      if($(this).hasClass('close-menu')) {
        mobileMenu.removeClass('open-mobile-menu')
        togglerMobileMenu.removeClass('close-menu')
        unlockScroll();
      } else {
        mobileMenu.addClass('open-mobile-menu')
        togglerMobileMenu.addClass('close-menu')
        lockScroll();
      }
    })
  }

  function closeMenu() {
    $('.header__toggler').on('click', function (e) {
      if ($(window).width() < 1024) {
        if (
          e.target.closest('.nav-mobile') === null &&
          e.target.closest('.navbar-toggler') === null
        ) {
          mobileMenu.removeClass('open-mobile-menu')
          body.removeClass('disabled')
          togglerMobileMenu.removeClass('close-menu')
          unlockScroll();
        }
      }
    });
  }

  function toggleMobileSubmenu() {
    mobileMenuToggleSubmenu.on('click', function() {
      mobileMenuToggleSubmenu.not(this).next().slideUp(500)
      mobileMenuToggleSubmenu.not(this).removeClass('active-link')
      $(this).next().slideToggle(500)
      $(this).toggleClass('active-link')
    })
  }

  function showDesktopSubmenu() {
    toggleSubmenu.hover(
      function () {
        const $submenu = $(this).children('ul');
        if ($submenu.length) {
          $submenu.addClass('active');
          $(this).children('a').first().addClass('active-link');
        }
      },
      function () {
        const $submenu = $(this).children('ul');
        if ($submenu.length) {
          $submenu.removeClass('active');
          $(this).children('a').first().removeClass('active-link');
        }
      }
    );

    toggleSubmenu.on('click', function () {
      const $submenu = $(this).children('ul');
      if ($submenu.length) {
        $submenu.toggleClass('active');
      }
    });
  }

  function closeMenuOnResize() {
    (function () {
      $(window).on('resize', function () {
        if ($(window).width() > 1023) {
          mobileMenu.removeClass('open-mobile-menu')
          body.removeClass('disabled')
          togglerMobileMenu.removeClass('close-menu')
          unlockScroll();
        }
      })
    })();
  }

  function enableDesktopSubmenuTab() {
    const desktopMenuItems = $('.header__nav-main ul .menu-item-has-children');

    desktopMenuItems.each(function () {
      const $li = $(this);
      const $link = $li.children('a');
      const $submenu = $li.children('ul');

      if (!$link.length || !$submenu.length) return;

      $link.on('focus', function () {
        desktopMenuItems.not($li).each(function () {
          $(this).children('ul').removeClass('active');
          $(this).children('a').removeClass('active-link');
        });

        $submenu.addClass('active');
        $link.addClass('active-link');
      });

      $li.on('focusout', function () {
        setTimeout(() => {
          if (!$li[0].contains(document.activeElement)) {
            $submenu.removeClass('active');
            $link.removeClass('active-link');
          }
        }, 0);
      });

      $li.on('keydown', function (e) {
        if (e.key === 'Escape') {
          $submenu.removeClass('active');
          $link.removeClass('active-link');
          $link.trigger('focus');
        }
      });
    });
  }

  function openChildMenu() {
    document.addEventListener('click', (e) => {
      const caret = e.target.closest('.menu-caret');
      if (!caret) return;

      e.preventDefault();
      e.stopPropagation();

      const li = caret.closest('.has-children');
      li.classList.toggle('open');
    });
  }

  function isHeroSlider() {
    if (document.querySelector('.hero-slider')) {
      document.querySelector('header')?.classList.add('has-hero-slider');
    }
  }

  function wpmlMenuCurrentLanguage() {
    document.querySelectorAll(".wpml-ls-current-language").forEach((wrap) => {
      const current = wrap.querySelector(":scope > a");
      const dropdown = wrap.querySelector(":scope > ul");

      if (!current || !dropdown) return;

      if (dropdown.querySelector(":scope > li.current-lang")) return;

      const clone = current.cloneNode(true);
      const li = document.createElement("li");
      li.classList.add("wpml-ls-item", "current-lang");
      li.appendChild(clone);
      dropdown.prepend(li);
    });
  }

  function enableDesktopSubmenuKeyboard() {
    const desktopMenuItems = $('.header__nav-main ul .menu-item-has-children');

    desktopMenuItems.each(function () {
      const $li = $(this);
      const $submenu = $li.find('> .submenu');
      const $link = $li.find('> a');

      if ($submenu.length === 0 || $link.length === 0) return;

      $link.attr({
        'aria-haspopup': 'true',
        'aria-expanded': 'false',
      });

      $link.on('focus', function () {
        desktopMenuItems.not($li).each(function () {
          const $other = $(this);
          $other.find('> .submenu').removeClass('active');
          $other.find('> a').removeClass('active-link').attr('aria-expanded', 'false');
        });

        $submenu.addClass('active');
        $link.addClass('active-link').attr('aria-expanded', 'true');
      });

      $li.on('focusout', function () {
        setTimeout(() => {
          if (!$li[0].contains(document.activeElement)) {
            $submenu.removeClass('active');
            $link.removeClass('active-link').attr('aria-expanded', 'false');
          }
        }, 0);
      });

      $li.on('keydown', function (e) {
        if (e.key === 'Escape') {
          $submenu.removeClass('active');
          $link.removeClass('active-link').attr('aria-expanded', 'false');
          $link.trigger('focus');
        }
      });
    });
  }

  return {
    init() {
      toggleHeaderScrolled();
      toggleMobileMenu();
      closeMenu();
      toggleMobileSubmenu();
      showDesktopSubmenu();
      closeMenuOnResize();
      openChildMenu()
      isHeroSlider()
      wpmlMenuCurrentLanguage()
      enableDesktopSubmenuKeyboard()
      enableDesktopSubmenuTab()
    },
  }
}

export {
  header,
}
